import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f997da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "center"
}
const _hoisted_4 = {
  key: 2,
  class: "center"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = {
  key: 5,
  class: "center"
}
const _hoisted_8 = { key: 6 }
const _hoisted_9 = { class: "line-through" }
const _hoisted_10 = {
  key: 8,
  class: "table__block-item-btn"
}
const _hoisted_11 = {
  key: 1,
  class: "headInColumn"
}
const _hoisted_12 = ["colspan"]

import { HeaderType, ItemType } from '@/types/TableTypes';
import { computed, ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTable',
  props: {
    headers: {},
    items: {},
    style: { default: 'base' },
    btns: {},
    showDropdown: { type: Boolean },
    dropDownCount: { default: 5 },
    headInColumn: { type: Boolean, default: false },
    withHeaders: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const isTableOpened: Ref<boolean> = ref(false);
const preparedItems = computed((): ItemType[] => {
  if (props.showDropdown && !isTableOpened.value) {
    return [...props.items].slice(0, props.dropDownCount);
  } else {
    return props.items;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.style, "table"])
  }, [
    (!_ctx.headInColumn)
      ? (_openBlock(), _createElementBlock("table", {
          key: 0,
          class: _normalizeClass([{ withBtns: !!_ctx.btns }, "table__block"])
        }, [
          (_ctx.withHeaders)
            ? (_openBlock(), _createElementBlock("thead", _hoisted_1, [
                _createElementVNode("tr", {
                  class: _normalizeClass(_ctx.style)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers.filter(el => !el.hide), (header, i) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: i,
                      class: _normalizeClass(_ctx.style),
                      style: _normalizeStyle({
              backgroundColor: header.backGroundColor,
              color: header.color,
              textAlign: header.align,
            }),
                      scope: "col"
                    }, _toDisplayString(header.text), 7))
                  }), 128))
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparedItems.value, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers.filter(el => !el.hide), (header, headerIndex) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: headerIndex,
                    class: _normalizeClass([[
              {
                yesIcon:
                  _ctx.style === 'firstColumnTitle' && item[header.value].value === true,
                noIcon:
                  _ctx.style === 'firstColumnTitle' && item[header.value].value === false,
                icon: item[header.value]?.icon !== undefined,
              },
              _ctx.style,
            ], "table__block-item"]),
                    style: _normalizeStyle({
              backgroundColor: item[header.value]?.bgColor ?? header.backGroundColumn,
              color: item[header.value]?.color ?? header.colorValue,
              textAlign: header.alignValue ?? header.align,
            })
                  }, [
                    (_ctx.$slots[header.value])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _renderSlot(_ctx.$slots, header.value, {
                            data: item[header.value]
                          })
                        ]))
                      : (item[header.value]?.isLoading === true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_base_spinner, { color: "#009D3E" })
                          ]))
                        : (item[header.value]?.value === true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(_component_base_icon, {
                                class: _normalizeClass({ 'firstColumnTitle-yes-icon': _ctx.style === 'firstColumnTitle' }),
                                color: "#009D3E",
                                height: "15",
                                name: "done",
                                width: "15"
                              }, null, 8, ["class"])
                            ]))
                          : (
                item[header.value]?.value === false && _ctx.style === 'firstColumnTitle'
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_base_icon, {
                                  class: "firstColumnTitle-no-icon",
                                  color: "#EA1F1F",
                                  height: "15",
                                  name: "close",
                                  width: "15"
                                })
                              ]))
                            : (item[header.value]?.value === false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                              : (item[header.value]?.icon !== undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(_component_base_icon, {
                                      name: item[header.value]?.icon,
                                      clickable: "",
                                      color: "#94857d",
                                      height: "18",
                                      width: "21",
                                      onClick: ($event: any) => (header.click ? header.click(item) : () => {})
                                    }, null, 8, ["name", "onClick"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(item[header.value]?.oldValue), 1),
                                    _createTextVNode(" " + _toDisplayString(item[header.value]?.value), 1)
                                  ])),
                    (_ctx.showDropdown && headerIndex === 0 && i === preparedItems.value.length - 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 7,
                          class: "table__block-item-btn gradient-color dropdown",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (isTableOpened.value = !isTableOpened.value))
                        }, _toDisplayString(isTableOpened.value ? 'Свернуть' : 'Развернуть'), 1))
                      : _createCommentVNode("", true),
                    (_ctx.btns && _ctx.btns[header.value] && i === preparedItems.value.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_base_button, {
                            text: _ctx.btns[header.value],
                            height: "35",
                            "style-type": "coloredBorder",
                            width: "99"
                          }, null, 8, ["text"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 6))
                }), 128))
              ]))
            }), 128))
          ])
        ], 2))
      : (_openBlock(), _createElementBlock("table", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers.filter(el => !el.hide), (header, headerIndex) => {
            return (_openBlock(), _createElementBlock("tr", { key: headerIndex }, [
              _createElementVNode("th", null, _toDisplayString(header.text), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparedItems.value.filter(el => el[header.value]), (item, i) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: i,
                  colspan: item[header.value]?.colspan
                }, _toDisplayString(item[header.value]?.value), 9, _hoisted_12))
              }), 128))
            ]))
          }), 128))
        ]))
  ], 2))
}
}

})